import React from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { InputSelect } from '@treelab/panda';

import { IDispatch, IRootState } from '../../../../modules/stores';

type IConnectProps = ReturnType<typeof mapState> & ReturnType<typeof mapDispatch>;
enum taskflowView {
  todo = 'todo',
  all = 'all',
  initiated = 'initiated',
  done = 'done',
}
interface taskflowViewName {
  title_zh: string;
  title_en: string;
}

const TASKFLOW_TAB_TITLE: Record<taskflowView, taskflowViewName> = {
  [taskflowView.todo]: {
    title_zh: '待我处理',
    title_en: 'Started by me',
  },
  [taskflowView.all]: {
    title_zh: '全部数据',
    title_en: 'All Data',
  },
  [taskflowView.initiated]: {
    title_zh: '我发起的',
    title_en: 'Started by me',
  },
  [taskflowView.done]: {
    title_zh: '已处理',
    title_en: 'Done',
  },
};

const SwitchView: React.FC<IConnectProps> = ({
  changeView,
  currentViewId,
  viewsAllIds,
  viewOptionById,
}) => (
  <InputSelect
    css={{ height: 32, width: 132, 'margin-right': '8px' }}
    input={{
      name: 'switchView',
      value: currentViewId,
      onChange: changeView,
    }}
    meta={{}}
    options={viewsAllIds.map((id: string) => {
      if (viewOptionById[id].name.split('.')[1] === 'system') {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const locale = urlParams.get('locale');
        const key = viewOptionById[id].name.split('.')[2];
        const viewName =
          locale === 'zh'
            ? TASKFLOW_TAB_TITLE[key as keyof Record<taskflowView, taskflowViewName>].title_zh
            : TASKFLOW_TAB_TITLE[key as keyof Record<taskflowView, taskflowViewName>].title_en;
        return {
          name: viewName,
          value: viewOptionById[id].id,
        };
      } else {
        return {
          name: viewOptionById[id].name,
          value: viewOptionById[id].id,
        };
      }
    })}
  />
);

const mapState = ({ core }: IRootState) => ({
  currentViewId: core.currentViewId,
  viewsAllIds: get(core, `tableOptionById[${core.currentTableId}].viewOptionsAllIds`, []),
  viewOptionById: core.viewOptionById,
});
const mapDispatch = ({ core }: IDispatch) => ({
  changeView: (payload: any) => core.changeView(payload),
});

export default connect(
  mapState,
  // @ts-ignore
  mapDispatch,
)(SwitchView);
